import { render, staticRenderFns } from "./BuyingListSuggestion.vue?vue&type=template&id=e398e63c&scoped=true"
import script from "./BuyingListSuggestion.vue?vue&type=script&lang=ts"
export * from "./BuyingListSuggestion.vue?vue&type=script&lang=ts"
import style0 from "./BuyingListSuggestion.vue?vue&type=style&index=0&id=e398e63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e398e63c",
  null
  
)

export default component.exports